import * as angular from 'angular';
import ConnectionStatusName from "./connectionStatus.directive";
import DatePickerName from "./date-picker";
import DateTimePickerName from "./date-time-picker";
import ElementReadyName from "./element-ready";
import InputEnterSubmitName from "./input-enter-submit.directive";
import ValidationName from "./validation.directives";
import KpiName from './kpi.directive';
import EquipmentGroupName from './equipment-group';
import VerticalTrendName from './vertical-trend';
import EquipmentBoxName from './equipment-box.directive';
import LineSelectionName from './line-selection.directive';

const requires = [
	ConnectionStatusName,
	DatePickerName,
	DateTimePickerName,
	ElementReadyName,
	ValidationName,
	InputEnterSubmitName,
	KpiName,
	EquipmentGroupName,
  VerticalTrendName,
  EquipmentBoxName,
  LineSelectionName
];

export default angular.module('aps.directives', requires).name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/directives/index.ts